module.exports = __webpack_public_path__ + "img/files.35624a15.svg";